<div class="main-content plp">
  <div class="container" [ngClass]="{'p-0': utils.screenSizeObj.width < 768}">
    <div class="d-flex flex-wrap">
      <div class="filter px-0" *ngIf="utils.screenSizeObj.width >= 768">
        <app-filters [filterData]="filterData"></app-filters>
      </div>
      <div class="listing">
        <ng-container *ngIf="matchesAnyPath()" id="items">
          <div class="product-banner" >
            <div class="carousel" class="position-relative" id="caraousel-scroll">
              <div class="d-flex align-items-baseline" id="items">
                <h1 class="text-transform-none mt-5" *ngIf="!isEshop && selectedDataForBreadCrumb && selectedDataForBreadCrumb.category">
                  {{checkSeriesName()?checkSeriesName():selectedDataForBreadCrumb.brandSubCategoriesMenus.subCategory}}
                </h1>
                <h1 class="text-transform-none" *ngIf="isEshop">{{plpText}}</h1>
                <span *ngIf="this.productList.length">{{this.productList.length}} Item{{this.productList.length >1?'s':''}}</span>
              </div>
              <ng-container *ngIf="matchesAnyPath()">
                <ng-container *ngIf="getImageData().imageUrl != null && getImageData().imageUrl != '' && getImageData().imageUrl != undefined">
                  <img loading="lazy" *ngIf="utils.screenSizeObj.width >= 768" [src]="getImageData().imageUrl" class="product mt-3 desktop-image" [alt]="getImageData().altText">
                  <img loading="lazy" *ngIf="utils.screenSizeObj.width < 768" [src]="getImageData().imageUrl" class="product mt-3 mobile-image" [alt]="getImageData().altText">
                </ng-container>
              </ng-container>
            </div>
          </div>
          <div class="product-description">
            <div class="inner-container">
              <span class="textJustify d-block h-100" [innerHTML]="getImageData().description"></span>
            </div>
          </div>
          <hr>
        </ng-container>
        <ng-container *ngIf="!matchesAnyPath()" id="items">
          <div class="breadcrumbs" *ngIf="!isEshop && selectedDataForBreadCrumb && selectedDataForBreadCrumb.category">
            <a routerLink="/">Home</a>
            <img loading="lazy" class="mx-3" [src]="environment?.blobUrl+'/assets/icons/chevron-right.svg'" alt="Home | Luminous">
            <a [routerLink]="getCategoryRoute()">{{selectedDataForBreadCrumb.category}}</a>
            <img loading="lazy" class="mx-3" [src]="environment?.blobUrl+'/assets/icons/chevron-right.svg'" [alt]="selectedDataForBreadCrumb.category">
            <a [routerLink]="getSubCatRoute()"
              (click)="!seriesGuid?reloadPage():''">{{selectedDataForBreadCrumb.brandSubCategoriesMenus.subCategory}}</a>
            <span *ngIf="seriesGuid">
              <img loading="lazy" class="mx-3" [src]="environment?.blobUrl+'/assets/icons/chevron-right.svg'" alt="Series Name | Luminous">
              <a class="text-transform-none" [routerLink]="router.url" (click)="reloadPage()">{{checkSeriesName()}}</a>
            </span>
          </div>
          <div class="breadcrumbs" *ngIf="isEshop">
            <a routerLink="/">Home</a>
            <img loading="lazy" class="mx-3" [src]="environment?.blobUrl+'/assets/icons/chevron-right.svg'" [alt]="plpText">
            <a [routerLink]="router.url" (click)="reloadPage()" class="text-transform-none">{{plpText}}</a>
          </div>
          <div class="d-flex align-items-baseline" id="items">
            <h1 class="text-transform-none" *ngIf="!isEshop && selectedDataForBreadCrumb && selectedDataForBreadCrumb.category">
              {{checkSeriesName()?checkSeriesName():selectedDataForBreadCrumb.brandSubCategoriesMenus.subCategory}}
            </h1>
            <h1 class="text-transform-none" *ngIf="isEshop">{{plpText}}</h1>
            <span *ngIf="this.productList.length">{{this.productList.length}} Item{{this.productList.length >1?'s':''}}</span>
          </div>
      </ng-container>
        <div [ngClass]="{'mt-3 mb-4': matchesAnyPath()}" class=" d-block d-lg-flex justify-content-between pincodeContainer">
          <div class="d-flex align-items-center" id="changeBtn">
            <span class="me-5" *ngIf="utils.getUserPicode()">Showing results for Pincode
              {{utils.getUserPicode()}}</span>
            <span class="me-5" *ngIf="!utils.getUserPicode()">Enter pincode to see product availability & delivery
              options</span>
            <div class="d-flex align-items-center">
              <span role="button" (click)="openPinCodeModel()">{{utils.getUserPicode()?'Change':'Add a pincode'}}
                <img loading="lazy" [src]="environment?.blobUrl+'/assets/icons/carbon_chevron-sort-down.svg'" alt="Pincode | Luminous"></span>
            </div>
          </div>
          <div class="d-flex filterBtnContainer">
            <div class="filterBtn" *ngIf="utils.screenSizeObj.width < 768" (click)="opneFilterModel()">
              <img loading="lazy" [src]="environment?.blobUrl+'/assets/images/product-listing/filter.svg'" class="ms-auto" alt="Compare Image | Luminous">
              Filter
            </div>
            <div class="filterBtn" id="compareBtn" (click)="compareProducts()">
              <img loading="lazy" [src]="environment?.blobUrl+'/assets/icons/compare.svg'" class="me-3" alt="Compare Image | Luminous"> {{isCompare? 'Go': 'Compare'}}
            </div>
          </div>
        </div>
        <div class="cardOuterContainer" *ngIf="productList && productList.length">
          <div class="cardContainer" *ngFor="let item of productList">
            <app-product-card [productData]="item" [isCompare]="isCompare"
              (submitProducts)="onProductsSubmit($event)"></app-product-card>
          </div>
        </div>
        <div class="row" *ngIf="productList && !productList.length">
          <div class="img-main text-center mt-5 mb-5">
            <img loading="lazy" [src]="environment?.blobUrl+'/assets/images/saved-items/saved-product-img.svg'" alt="No Product Available | Luminous">
            <p>No Product Available</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="faqContainer" *ngIf="faqData && faqData.length">
    <div class="container">
      <app-faq-page [faqData]="faqData"></app-faq-page>
    </div>
  </div>
</div>
<div [innerHtml]="structuredData"></div>
